(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mini-cart-footer"] && !Shopify.designMode) return;
  try {
    (function() {

  function updateMiniCartCheckout() {

    const checkbox = document.getElementById('mini-cart-terms-checkbox');
    const checkoutButton = document.getElementById('mini-cart-checkout');

    if (!checkbox || !checkoutButton) return;

    checkoutButton.disabled = !checkbox.checked;

  }


  // Handle checkbox changes using event delegation.
  // This continues to work even if Shopify/Athens replaces
  // the mini-cart HTML after the page loads.

  document.addEventListener('change', function(event) {

    if (event.target && event.target.id === 'mini-cart-terms-checkbox') {

      event.stopImmediatePropagation();

      updateMiniCartCheckout();

    }

  }, true);


  // Handle checkout clicks

  document.addEventListener('click', function(event) {

    if (event.target && event.target.closest('#mini-cart-checkout')) {

      const checkbox = document.getElementById('mini-cart-terms-checkbox');

      if (!checkbox || !checkbox.checked) {

        event.preventDefault();
        event.stopImmediatePropagation();

        const error = document.getElementById('mini-cart-terms-error');

        if (error) {
          error.style.display = 'block';
        }

        if (checkbox) {
          checkbox.focus();
        }

        return false;

      }

    }

  }, true);


  // Keep the button state correct whenever the mini-cart is
  // dynamically updated by Shopify/Athens.

  const observer = new MutationObserver(function() {
    updateMiniCartCheckout();
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  // Initial check

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', updateMiniCartCheckout);

  } else {

    updateMiniCartCheckout();

  }

})();
  } catch(e) { console.error(e); }
})();

})();
